gameDiv = document.getElementById("game");
maxRounds = 25; // 25
currentRound = 1
averageReactionTime = 1;
chanceOfColorChange = 0.3; // 0.3
millisecondsToChangeColor = 1100; // 1000


function showCircle(color) {
    console.log("showCircle");
    circle = document.createElement("div");
    circle.id = 'circle';
    circle.style.backgroundColor = color;
    gameDiv.appendChild(circle);
}


function maybeChangeOpacity() {
    console.log("maybechangeOpacity");
    if (Math.random() < chanceOfColorChange) {
        console.log('changing color')
        return true 
    } else {
        console.log('keeping color')
        return false
    }
}


function lowerOpacity() {
    // get current timestamp
    timestamp = Date.now()
    console.log("changing opacity now!");
    circleDiv = document.getElementById('circle')
    opacity = circleDiv.style.opacity || 1
    
    let interval = setInterval(() => {
        opacity -= 0.01; 
        circle.style.opacity = opacity; 
    
        if (opacity <= 0) {
            clearInterval(interval); 
            endRound()
        }
    }, 20)
}

function endRound() {
    circleDiv = document.getElementById('circle')
    circleDiv.remove()
    console.log('circle removed')
    currentRound += 1

    document.getElementById('reaction').removeEventListener('click', getTime)

    if (currentRound <= maxRounds) {
        runRound()
    } else {
        endGame()
    }
}

function getTime() {
    
        if (startTime) {
            const endTime = performance.now(); // Get the current time when the button is clicked
            const elapsedTime = (endTime - startTime)/1000; // Calculate the time difference
            console.log(elapsedTime)
            updateReactionTime(elapsedTime)
            
            document.getElementById('reaction').innerHTML = 'Ok!'
            setTimeout(() => {
                document.getElementById('reaction').innerHTML = 'Ich sehe eine Änderung!'
            }, 300);

            

            document.getElementById('reaction').removeEventListener('click', getTime)
            
        }
    
}


function getReactionTime() {
    console.log("startReactionTimeInterval");
    startTime = null;
    startTime = performance.now()
    console.log('adding event listener')
    document.getElementById('reaction').addEventListener('click', getTime);
}


function updateReactionTime(elapsedTime) {
    averageReactionTime = (averageReactionTime + elapsedTime) / 2
    document.getElementById('avgTime').innerHTML = averageReactionTime.toFixed(2)
    
}


function updateRound() {
    document.getElementById('maxRounds').innerHTML = maxRounds
    document.getElementById('currentRound').innerHTML = currentRound
    
}



function runRound() {
    updateRound()
    showCircle(randomDarkColor())
    
    colorInterval = setInterval(function() {
        if (maybeChangeOpacity()) {
            getReactionTime()
            clearInterval(colorInterval)
            lowerOpacity()
        }
    }, millisecondsToChangeColor)
    
}


function startGame() {
    document.getElementById('startGame').remove()
    document.getElementById('game').style.display = 'block'
    document.getElementById('round').style.display = 'block'
    document.getElementById('reaction').style.display = 'block'
    runRound()
}

function endGame () {
    console.log('game ended')
    document.getElementById('reaction').remove()
    newGameLink = document.createElement('a')
    newGameLink.id = 'newGame'
    newGameLink.href = '.'
    document.getElementById('stats').style.display = 'block'
    document.getElementById('round').style.display = 'none'
    document.getElementById('game').style.display = 'none'
    newGameLink.innerHTML = '</br>Erneut probieren </br>'
    document.getElementById('stats').appendChild(newGameLink)
    
}

function nextRound() {
    runRound()
}




function randomDarkColor() {
    var darkColors = [
        "#2c3e50", // Dunkelblau-Grau
        "#34495e", // Dunkelgrau-Blau
        "#7f8c8d", // Mittelgrau
        "#2980b9", // Dunkelblau
        "#2ecc71", // Dunkelgrün
        "#8e44ad", // Dunkles Violett
        "#c0392b", // Dunkelrot
        "#d35400", // Orange
        "#27ae60", // Dunkelgrün
        "#f39c12", // Orange-Gelb
        "#16a085", // Dunkles Türkis
        "#e74c3c", // Helles Rot
    ]

    randomColor = darkColors[Math.floor(Math.random() * darkColors.length)];
    return randomColor
}

